import { Accordion, AccordionDetails, useEventCallback } from '@mui/material';
import { memo, useMemo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { headCellsCitizenship, headCellsCitizenshipEditMode } from './constants';
import { useFormikContext } from 'formik';
import { AccordionTitle } from 'shell/components/shared/accordion-title';
import { CitizenshipVM } from 'shell/view-models/citizenship';
import CitizenshipForm from 'shell/components/shared/citizenship-form';
import { HeadCell } from 'shell/components/shared/table/types';
import { RegistrationCitizenshipFormVM } from 'mutation/view-models/registration-citizenship';

interface CitizenshipProps {
  isEditMode?: boolean;
}

const CitizenshipListComponent = ({ isEditMode }: CitizenshipProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const formContext = useFormikContext<RegistrationCitizenshipFormVM>();

  const onDelete = useEventCallback((citizen: CitizenshipVM) => {
    const citizens = formContext.values.citizenship?.slice() || [];

    const filteredCitizens = citizens.filter(
      (citizeToFilter) => citizeToFilter.code !== citizen.code
    );

    formContext.setFieldValue('newCitizenship', filteredCitizens);
  });

  const headCells: HeadCell<CitizenshipVM, keyof CitizenshipVM>[] = useMemo(() => {
    return !isEditMode ? headCellsCitizenship : headCellsCitizenshipEditMode;
  }, [isEditMode]);

  const onAddToTable = useEventCallback((values: Array<CitizenshipVM>) => {
    formContext.setFieldValue('citizenship', values);
  });

  return formContext.values.citizenship ? (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-citizenship-content"
        id="panel-person-citizenship-header"
        expandIcon={<ExpandMore />}
      >
        <AccordionTitle isEditMode={isEditMode}>Cittadinanza</AccordionTitle>
      </AccordionSummary>
      <AccordionDetails>
        <CitizenshipForm
          headCells={headCells}
          isEditMode={isEditMode || false}
          onAddToTable={onAddToTable}
          citizens={formContext.values.citizenship as Array<CitizenshipVM>}
          onDelete={onDelete}
          dateControl={formContext.values.editDataControl?.dateValidity}
        />
      </AccordionDetails>
    </Accordion>
  ) : (
    <></>
  );
};

CitizenshipListComponent.displayName = 'Citizenship List component';

const CitizenshipList = memo(CitizenshipListComponent);

export default CitizenshipList;
